import { view } from "@risingstack/react-easy-state";
import { Grid } from "@tine/designsystem-ui-react";
import isEmpty from "lodash-es/isEmpty";
import { useInView } from "react-intersection-observer";
import { Link } from "wouter";

import { productImageUrl } from "../common/imageUtils";
import { queueImpression, sendProductClick } from "../common/tracking";
import type { Product } from "../common/types/productTypes";
import { LIST_TYPE } from "../common/types/trackingTypes";

import productStore from "../stores/product/productStore";

const listName = "Relaterte produkter på PDP";

type RelatedProductProps = {
   product: Product;
   position: number;
   listLength: number;
};

const RelatedProduct = view(({ product, position, listLength }: RelatedProductProps) => {
   const trackClick = (product: Product, position: number) => {
      sendProductClick(product, { type: LIST_TYPE.RELATED_PRODUCTS, name: listName, length: listLength }, position);
   };
   const trackImpression = (isVisible: boolean) => {
      if (isVisible) {
         queueImpression(product, listName, position);
      }
   };

   const { ref } = useInView({
      onChange: trackImpression,
      triggerOnce: true
   });

   return (
      <div className="tw-mb-4 tw-flex tw-flex-col" ref={ref}>
         <Link onClick={() => trackClick(product, position)} to={productStore.getUrl(product)}>
            <img
               alt={`Bilde av ${product.name}`}
               className="tw-mx-auto tw-mb-2 tw-w-3/4"
               src={productImageUrl(product.sku, 150)}
            />
         </Link>
         <div className="tw-break-words">{product.name}</div>
      </div>
   );
});

type RelatedProductsProps = {
   skus: string[];
};

const RelatedProducts = ({ skus }: RelatedProductsProps) => {
   const products = productStore.resolveSkus(skus);

   return (
      <Grid cols={{ base: 2, sm: 3, md: 5, lg: 2 }} gap={{ base: 2, lg: 0 }} className="tw-w-full tw-text-xs">
         {products.map((p, i) => (
            <RelatedProduct key={p.sku} product={p} position={i + 1} listLength={products.length} />
         ))}
         {isEmpty(products) && (
            <p className="tw-mx-auto tw-my-4 tw-w-full tw-text-center tw-text-muted">Ingen relaterte produkter.</p>
         )}
      </Grid>
   );
};

export default view(RelatedProducts);
